<template>
  <div class="bottomVert" v-if="faces.length">
    <gmap-map
      class="infoBorder gmap"
      :center="{
        lat: faces[0].latitude,
        lng: faces[0].longitude
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="mapReseauxPersonnalise"
      @tilesloaded="initCarto">
      <gmap-marker
        v-for="(m, index) in faces"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude
        }"
        @click="detailFace = m, show = true"
        :icon="icon(m.color, m)">
      </gmap-marker>
    </gmap-map>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-reseaux-personnalise-complet
        :bg="bg"
        :detailFace="detailFace"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import detailReseauxPersonnaliseComplet from './detailReseauxPersonnaliseComplet';

export default {
  name: 'carteReseauxPersonnalise',
  props: ['faces', 'couleur'],
  components: {
    appDetailReseauxPersonnaliseComplet: detailReseauxPersonnaliseComplet,
  },
  data() {
    return {
      detailFace: {},
      show: false,
      colorIcon: '#c242f4',
      bg: false,
      isLoadOnce: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  methods: {
    async levelZoom() {
      const bounds = new google.maps.LatLngBounds();
      filterLatLng(this.faces);
      this.faces.forEach(m => {
        if (m.latitude !== 0 && m.longitude !== 0
        && m.latitude !== null && m.longitude !== null) {
          bounds.extend({ lat: m.latitude, lng: m.longitude });
        }
      });
      this.$refs.mapReseauxPersonnalise.fitBounds(bounds);
    },
    icon(color, face) {
      if (face.codeFormat === '4' || face.codeFormat === '3' || face.formatCode === '4' || face.formatCode === '3') {
        if (!color) return iconColorGetter(this.couleur, TAILLE_ICON_GRAND, face.azimut, true);
        return iconColorGetter(color, TAILLE_ICON_GRAND, face.azimut, true);
      }
      if (!color) return iconColorGetter(this.couleur, TAILLE_ICON_PETIT, face.azimut, true);
      return iconColorGetter(color, TAILLE_ICON_PETIT, face.azimut, true);
    },
    async initPoi() {
      const map = await this.$refs.mapReseauxPersonnalise.$mapPromise;
      const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
        name: MAP_TYPE_NAME,
      });
      map.mapTypes.set('styled_map', styleMap);
    },
    async initCarto() {
      if (!this.isLoadOnce) {
        await this.initPoi();
        if (this.faces.length) {
          await this.levelZoom();
        }
        this.isLoadOnce = true;
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxPersonnalise/carteReseauxPersonnalise.vue